import { useTranslation } from 'react-i18next'

import { TriggerCellProps } from './types'

export const TriggerCell = ({ page }: TriggerCellProps): React.JSX.Element => {
  const { t } = useTranslation('features/page', { keyPrefix: 'list.triggers' })
  const { customVariableTriggerEnabled, pathTriggerEnabled } = page
  const triggers: string[] = []

  if (customVariableTriggerEnabled) {
    triggers.push(t('customVariableTriggerEnabled'))
  }

  if (pathTriggerEnabled) {
    triggers.push(t('pathTriggerEnabled'))
  }

  return <>{triggers.join(', ')}</>
}
